import type { OrderStatus } from "@/api/types";

const LABELS: Record<OrderStatus, string> = {
  pending_approval: "承認待ち",
  approved: "承認済み",
  shipping: "出荷中",
  completed: "完了",
  cancelled: "キャンセル",
};

const CLASSES: Record<OrderStatus, string> = {
  pending_approval: "badge-yellow",
  approved: "badge-blue",
  shipping: "badge-blue",
  completed: "badge-gray",
  cancelled: "badge-red",
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  return <span className={CLASSES[status]}>{LABELS[status]}</span>;
}
